import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { Error } from "@helpers";

// TODO JS user friendly error handling + logging
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error): void => {
      Error("Query error:", error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error): void => {
      Error("Mutation error:", error);
    },
  }),
});
